import Link from './Link.vue'

export default Link
